module.exports = __webpack_public_path__ + "img/img012.3bd00113.png";